import React, { useContext, useRef, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { GALLERY } from '../utils/constants'
import PropTypes from 'prop-types'

export const GalleryContext = React.createContext({
  addResults: () => undefined,
  getImages: () => [],
  openGallery: () => undefined
})

const createInitialGalleryUrl = (slide, site) => {
  const sitePath = site === 'us' ? '' : `/${site}`
  const { slug: imageSlug, parent: { id, slug } = {} } = slide
  return `${sitePath}/${GALLERY}/${id}/${slug}/${imageSlug}`
}

const GalleryProvider = ({ site, children }) => {
  const history = useHistory()
  const { location } = history

  const galleryResults = useRef([])

  const getImages = useCallback(() => {
    return galleryResults.current
  }, [galleryResults.current])

  const addResults = (newImages, page = 1, reset) => {
    if (reset) {
      galleryResults.current = []
    }

    const baseResultIndex = (page - 1) * 18
    const formattedResults = newImages.filter(item => item.images.length > 0)
      .map(({ parent_info: parent, images }, index) => {
        const total = images.length
        const resultIndex = baseResultIndex + index
        return images.map((img, imageIndex) => ({
          ...img,
          parent,
          total,
          resultIndex,
          relativeIndex: imageIndex
        }))
      }).flat()

    galleryResults.current = [...galleryResults.current, ...formattedResults]
  }

  const openGallery = (e, imageIndex = 0, resultIndex = 0) => {
    if (e.target.matches('.myad-save-button__box')) {
      return true
    }
    const slide = galleryResults.current.find(img => img.resultIndex === resultIndex && img.relativeIndex === imageIndex)

    if (slide === undefined) {
      // eslint-disable-next-line no-console
      console.error(`Slide for result ${resultIndex} - image ${imageIndex} was not found`)
    }

    if (e.target.matches('.myad-save-button__box')) {
      return true
    }
    e.stopPropagation()
    const path = {
      pathname: createInitialGalleryUrl(slide, site),
      state: { background: location, backgroundProps: { resultIndex, imageIndex } }
    }
    history.push(path)
  }

  return (
    <GalleryContext.Provider value={{ addResults, openGallery, getImages }}>
      {children}
    </GalleryContext.Provider>
  )
}

function useGallery () {
  const context = useContext(GalleryContext)
  if (context === undefined) {
    throw new Error('useGallery has to be used within GalleryProvider')
  }
  return context
}

GalleryProvider.propTypes = {
  site: PropTypes.string,
  children: PropTypes.node
}

export { GalleryProvider, useGallery }
